module.exports = __webpack_public_path__ + "img/opdracht-pauze.1a048801.png";